export default "__VITE_ASSET__BWnhTSNz__"